export interface FulfillmentOutlet {
  id: string
  name: string
}
export enum STEPS {
  METHOD = 1,
  CUSTOMER = 2,
  ADD = 3,
  DETAILS = 4,
}
